// This file was automatically generated from print.messageThreads.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.messageThreads');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.messageThreads.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  output.append('<h1 class="documentTitle">Office Message</h1>');
  el8.template.print.patientInfo(opt_data, output);
  output.append('<div class="spacer"></div><p>Message between ');
  var memberList15713 = opt_data.thread.members;
  var memberListLen15713 = memberList15713.length;
  for (var memberIndex15713 = 0; memberIndex15713 < memberListLen15713; memberIndex15713++) {
    var memberData15713 = memberList15713[memberIndex15713];
    output.append(soy.$$escapeHtml(memberData15713.name), (! (memberIndex15713 == memberListLen15713 - 1)) ? ', ' : '');
  }
  output.append('</p><div class="spacer"></div><table>');
  var mList15720 = opt_data.thread.messages;
  var mListLen15720 = mList15720.length;
  for (var mIndex15720 = 0; mIndex15720 < mListLen15720; mIndex15720++) {
    var mData15720 = mList15720[mIndex15720];
    output.append('<tr><td class="messageDate"><p>', (soy.$$escapeHtml(mData15720.sendDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(mData15720.sendDate)) : ''), '</p></td><td class="messageContent"><p class="messageAuthor">', soy.$$escapeHtml(mData15720.senderName), '</p><p class="preserve">', soy.$$escapeHtml(mData15720.body), '</p></td></tr>');
  }
  output.append('</table></div>');
  if (!opt_sb) return output.toString();
};
